
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { mapGetters } from "vuex";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputNumber from "primevue/inputnumber";
import Tag from "primevue/tag";
import Utils from "@/utility/utils";

export default defineComponent({
  name: "POSPartsTable",
  components: {
    DataTable,
    Column,
    Button,
    InputNumber,
    Tag,
  },
  props: {
    value: {
      type: Array,
      default: () => [] as any[],
    },
    scrollHeight: {
      type: String,
      default: "55vh",
    },
    showAddToCartBtn: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showPaginator: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "row-click",
    "add-to-cart",
  ],
  setup() {
    const isMobile = ref(false);

    const checkMobileView = () => {
      isMobile.value = window.innerWidth <= 768;
    };

    onMounted(() => {
      checkMobileView();
      window.addEventListener('resize', checkMobileView);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobileView);
    });

    return {
      isMobile,
    };
  },
  computed: {
    ...mapGetters({
        getSelectedCoCode: "control/getSelectedCoCode"
    })
  },
  methods: {
    onRowClick(event: any) {
      this.$emit("row-click", event);
    },
    addItem(part: any) {
      this.$emit("add-to-cart", part);
    },
    formatPrice(amount: number | string) {
      return Utils.formatPrice(amount);
    },
    calculateStep(part: any) {
      return Utils.calculateQtyStep(part);
    },
    getStdPrice(price: any) {
      const quantity = price.quantity || 1;
      let price_value = "";
      if (price.std_price_items) {
        if (price.std_price_items.length === 1) {
          price_value = price.std_price_items[0].std_price;
        } else {
          price.std_price_items.forEach((std_item: any) => {
            const std_quantity = parseFloat(std_item.std_qty);
            if (quantity >= std_quantity) {
              price_value = std_item.std_price;
            }
          });
        }

        // If there is no valid price with quantitys default to first option.
        if (price_value === "") {
          price_value = price.std_price_items[0].std_price;
        }
      }
      if (price_value) {
        return price_value;
      }
      return "0";
    },
    getCodePrice(price: any) {
      const quantity = price.quantity || 1;
      const code_price = price.code_items?.find(
        (item: any) => item.code === this.getSelectedCoCode
      );
      let price_value = "";
      if (code_price && code_price.code_price_items) {
        if (code_price.code_price_items.length === 1) {
          price_value = code_price.code_price_items[0].code_price;
        } else {
          code_price.code_price_items.forEach((code_item: any) => {
            const code_quantity = parseFloat(code_item.code_qty);
            if (quantity >= code_quantity) {
              price_value = code_item.code_price;
            }
          });
        }
      }

      if (price_value) {
        return price_value;
      }
      return "";
    },
    updatePrice(event: any, part: any) {
      if (event && event.value != part.quantity) {
        part.quantity = event.value;
      }
      const std_price = this.getStdPrice(part);
      const code_price = this.getCodePrice(part);
      if (code_price) {
        part["price"] = code_price;
      } else {
        part["price"] = std_price;
      }
    },
    buttonColor(quantity: number) {
      return quantity > 0
        ? "background-color: var(--default-button-color)"
        : "background-color: grey";
    },
    getAvailableQuantity(data: any) {
      // Return the available quantity, handling both available and avail_qty fields
      // Return undefined if stock data hasn't been loaded yet
      if (data.available !== undefined) {
        return parseInt(data.available);
      }
      if (data.avail_qty !== undefined && data.avail_qty !== null) {
        return parseInt(data.avail_qty) || 0;
      }
      
      return undefined; // Stock data not loaded yet (null or undefined) or loading
    },
    handleOnHandTagText(avail_qty: number) {
      return avail_qty > 0 ? "In Stock" : "Out of Stock";
    },
    handleOnHandTagColor(avail_qty: number) {
      return avail_qty > 0 ? "success" : "danger";
    },
    getRowClass(data: any) {
      return data.required === 'Y' ? 'required-part' : '';
    },
  },
});
